import { Outlet } from 'react-router-dom';
import { sidebarData } from './Tlsidebar';
import DashboardSidebar from "../../layout/DashboardSidebar";
import React, { useEffect, useState } from 'react'
import { Modal } from "react-bootstrap";
import usePermission from '../../config/permissions';

const EmployeeDashboard = () => {

  const [isexpand, setExpanded] = useState(false);
  const [show, setShow] = useState(false); //Announcement Notify
  const handleClose = () => setShow(false);

  const [sidebarDetails, setSidebarDetails] = useState([]);
  const permissions = usePermission();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // tablet breakpoint

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Get fresh values from sessionStorage
    const is_rh = sessionStorage.getItem('is_rh') === 'true' || sessionStorage.getItem('is_rh') === true;
    const emp_code = sessionStorage.getItem('emp_code');
    const department_name = sessionStorage.getItem('department_name');

    // Process sidebar config with current permissions
    const processSidebarItem = (item) => {
      if (item.condition) {
        // If item has a condition function, evaluate it
        const conditionMet = item.condition({ is_rh, emp_code, department_name, permissions });
        if (!conditionMet) return null;
      }

      if (item.subMenu) {
        // Process submenu items
        const processedSubMenu = item.subMenu
          .map(subItem => processSidebarItem(subItem))
          .filter(Boolean);

        if (processedSubMenu.length === 0 && item.hideIfEmpty) {
          return null; // Hide parent if no submenu items and hideIfEmpty is true
        }

        return { ...item, subMenu: processedSubMenu };
      }

      return item;
    };

    const processedData = sidebarData
      .map(item => processSidebarItem(item))
      .filter(Boolean);

    setSidebarDetails(processedData);
  }, [permissions]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  return (
    <>
      <div className="dashboard-main-section">
        <div className='hamburger-overlay'>
          <button
            className={`mobile-hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle sidebar"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div
          className={`mobile-sidebar-overlay ${mobileMenuOpen ? 'mobile-open' : ''}`}
          onClick={toggleMobileMenu}
        />
        <DashboardSidebar sidebarData={sidebarDetails} isexpand={isexpand} setExpanded={setExpanded} mobileMenuOpen={mobileMenuOpen} closeMobileMenu={() => setMobileMenuOpen(false)} isMobile={isMobile} />
        <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnn"}>
          <Outlet />
        </div>

        <Modal show={show} onHide={handleClose} dialogClassName="model-annoucee">
          <Modal.Header closeButton>

          </Modal.Header>
          <Modal.Body >
            <img src="https://civilmantra.s3.ap-south-1.amazonaws.com/Ashish+Dhaiya.png" alt="demo" className="model-annoucee-pic" />

            {/* <img src="https://cipl-aimantra.s3.ap-south-1.amazonaws.com/employee_profilepics/White+Gold+black+Modern+Minimalist+Best+Employee+Greeting+Instagram+Story+(1200+x+1800+px)+(1800+x+1200+px).png" alt="demo" className="model-annoucee" /> */}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};


export default EmployeeDashboard
